import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'clemos-conversation-list-item',
  templateUrl: './conversation-list-item.component.html',
  styleUrls: ['./conversation-list-item.component.css']
})
export class ConversationListItemComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
